import { render, staticRenderFns } from "./SliderQuestion.vue?vue&type=template&id=cc4bd81c&"
import script from "./SliderQuestion.vue?vue&type=script&lang=js&"
export * from "./SliderQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports